var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurtain = function SvgCurtain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 2C9.5 4.333 6.9 9.3.5 10.5c2.5 1 5.5 3 5.5 6v2H.5V2zM10 2c.5 2.333 3.1 7.3 9.5 8.5-2.5 1-5.5 3-5.5 6v2h5.5V2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 1,
    x: 9.5,
    y: 17,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 9.5 17)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 1,
    x: 6,
    y: 16,
    fill: "currentColor",
    rx: 0.5
  })));
};
export default SvgCurtain;